import cn from 'clsx'

import styles from './card.css'

type CardProps = {
  children: JSX.Element | Array<JSX.Element | null>
  size?: 'large'
  className?: string
}
const Card = ({ children, size, className }: CardProps) => (
  <div className={cn(styles.wrapper, size && styles[size], className)}>{children}</div>
)

const Divider = () => <hr className={styles.divider} />

Card.Divider = Divider

export default Card
